export const CURIOUS = 'curious'
export const SNICKERING = 'snickering'
